"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDistinctValues = void 0;
const getDistinctValues = searchTerms => searchTerms.filter((term, index) => searchTerms.indexOf(term) === index);
exports.getDistinctValues = getDistinctValues;
